import * as React from "react";
import type { SVGProps } from "react";
const SvgOnePersonCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#one-person-circle_svg__a)">
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8" />
      <path d="M18.16 18.96c-.55 0-1-.45-1-1 0-1.08-1.15-1.96-2.56-1.96H9.4c-1.41 0-2.56.88-2.56 1.96 0 .55-.45 1-1 1s-1-.45-1-1C4.84 15.78 6.88 14 9.4 14h5.2c2.51 0 4.56 1.78 4.56 3.96 0 .55-.45 1-1 1M12 13.5c-1.81 0-3.3-1.44-3.4-3.27l-.09-1.69C8.51 6.56 10.05 5 11.93 5h.15c1.89 0 3.43 1.56 3.43 3.49l-.1 1.74c-.1 1.83-1.6 3.27-3.4 3.27zM11.93 7c-.79 0-1.43.67-1.43 1.49l.09 1.63c.04.78.66 1.38 1.41 1.38s1.37-.61 1.41-1.38l.09-1.69c0-.76-.64-1.43-1.43-1.43h-.15z" />
    </g>
    <defs>
      <clipPath id="one-person-circle_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOnePersonCircle;
